<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    JO Approved
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="exportData()">
                    <v-icon class="mr-2">mdi-download</v-icon> Export
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.name`]="{ item }">
        <a @click="viewDrawDetail(item)">{{ item.name }}</a>
      </template> -->

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <!-- <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template> -->

            <template v-slot:[`item.status`]="{ item }">
              {{ item.Status ? "--" : "--" }}
              <!-- {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }} -->
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <!-- <v-btn
                x-small
                color="pink"
                class="mr-1"
                dark
                @click="reject(item)"
              >
                Reject</v-btn
              > -->
              <v-btn x-small color="primary" dark @click="approved(item)">
                Edit</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <ConfirmationDiaglog
      :dialog="confimationDialog.dialog"
      :message="confimationDialog.message"
      :title="confimationDialog.title"
      @response="confimationDialogResponse"
    ></ConfirmationDiaglog>
    <Snackbar></Snackbar>
    <ApproveJoDialog
      :dialog="approvedDialog.dialog"
      :data="selectedJO"
      @response="approveJoDialogResponse"
    ></ApproveJoDialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglog.vue";
import Snackbar from "../dialogs/Snackbar.vue";
import ApproveJoDialog from "../dialogs/acquisition/ApproveJoDialog.vue";
export default {
  components: {
    ConfirmationDiaglog,
    Snackbar,
    ApproveJoDialog,
  },
  data() {
    return {
      confimationDialog: {
        dialog: false,
        message: "",
        title: "",
      },

      approvedDialog: {
        dialog: false,
      },
      selectedJO: {},
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Sign up Date",
            align: "start",
            sortable: false,
            value: "createdDate",
            formatter: (x) => (x ? moment(x).format("MMMM DD, YYYY") : null),
          },
          // firstName, lastName, city, address
          {
            text: "First name",
            align: "start",
            value: "firstName",
          },
          {
            text: "Last name",
            align: "start",
            value: "lastName",
          },
          {
            text: "Address",
            align: "start",
            value: "address",
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },

          {
            text: "NAP Code",
            align: "start",
            value: "napCode",
            sortable: false,
          },
          {
            text: "Port",
            align: "start",
            value: "port",
            sortable: false,
          },
          // {
          //   text: "Status",
          //   align: "center",
          //   value: "status",
          //   sortable: false,
          // },
          {
            text: "Actions",
            align: "center",
            value: "actions",
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=approved-jo")
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data;
          // console.log(newArr)
          this.table.data = newArr.subscribers;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async approved(data) {
      this.selectedJO = data;
      this.approvedDialog.dialog = true;
    },

    async reject(data) {
      this.confimationDialog.title = "Reject";
      this.confimationDialog.message =
        "Are you sure you want to reject this JO?";
      this.confimationDialog.dialog = true;
      this.selectedJO = data;
      // console.log(data);
    },

    async doReject() {
      // this.table.loading = true;
      await this.$api
        .delete("/dashboard/jo-approver", {
          data: { _id: this.selectedJO._id },
        })
        .then((response) => {
          // console.log(response.data);
          const res = response.data;
          // console.log(newArr);
          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.confimationDialog.dialog = false;
          this.getList();
          // this.table.data = newArr.subscribers;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },

    confimationDialogResponse(response) {
      // console.log(response);
      if (!response) {
        this.confimationDialog.dialog = false;
        return;
      }

      this.doReject();
    },

    approveJoDialogResponse(response) {
      if (!response) {
        this.approvedDialog.dialog = false;
        return;
      }

      const _id = this.selectedJO._id;
      let data = { ...response, _id };
      // console.log(data);
      this.doApproved(data);
    },

    async doApproved(data) {
      console.log(data);
      await this.$api
        .post("/dashboard/jo-approver", data)
        .then((response) => {
          const res = response.data;
          // console.log(newArr);
          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.approvedDialog.dialog = false;
          this.getList();
          // this.table.data = newArr.subscribers;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
